
import React from "react";
import { useIPCBridge } from "../hooks/useIPCBridge";
import { useStateContext } from "../hooks/useStateContext";
import { environment } from "../util";
import ConnectionCheckView from "./ConnectionCheckView";
import { useDedupEffect } from "../util/useDedupEffect";
const logPrefix = "[ADPClient][RedirectionView]"
export default function RedirectionView(){
  const { state, dispatch } = useStateContext();
  const {saveADPChromeAppState,startAssessment} = useIPCBridge(dispatch,state);
  let url = `${environment.resolveENAEPDomain()}/login/index.html?`;
  if(state.sessionState.selectedAssessmentMode === "ncs" && state.connectedNCSState){
    url =`${state.connectedNCSState.config.staticServices.assessmentEntryUrl}&`
  }
  let urlWithParams = `${url}adpLaunchId=${state.appState.appLaunchId}&setupcode=${state.sessionState.schoolDetails?.setupCode}&deviceId=${state.deviceState.deviceId}&locale=${state.sessionState.schoolDetails?.isPR ? "es" :"en"}&version=${state.appState.releaseVersion}&assessmentMode=${state.sessionState.selectedAssessmentMode}&deviceType=${state.deviceState.deviceType}`;
  if(state.sessionState.selectedAssessmentLocation?.locationId && state.sessionState.selectedAssessmentLocation?.label){
    urlWithParams = `${urlWithParams}&selectedAssessmentLocationLabel=${state.sessionState.selectedAssessmentLocation?.label}&selectedAssessmentLocationLocationId=${state.sessionState.selectedAssessmentLocation?.locationId}`
  }
  console.log(logPrefix,"redirecting to:", url);
  useDedupEffect(() => {
    saveADPChromeAppState(state);
    startAssessment();
    setTimeout(()=>{
      if(state.sessionState.selectedAssessmentMode === "online"){
             window.location.replace(urlWithParams);
     }
     else if(state.sessionState.selectedAssessmentMode === "ncs"){
           const appState = {
                               clientLaunchId: state.appState.appLaunchId ,
                               content: state.staticContent,
                               selectedAssessmentMode: state.sessionState?.selectedAssessmentMode,
                               setupCode: state.sessionState?.schoolDetails?.setupCode,
                               deviceId:state.deviceState?.deviceId,
                               appLaunchId:state.appState.appLaunchId 
           }
           const queryParams = new URLSearchParams(JSON.stringify(appState)).toString();
           window.location.replace(`${urlWithParams}&state=${queryParams}`);
         }
    },500)
 
}, []);
    return (
      <ConnectionCheckView />
    )
}